import React, { useState, useMemo, useEffect } from 'react';
import './Development.scss';
import Uses from './Uses/Uses';
import Sources from './Sources/Sources';
import { DevelopmentValues } from '../types';
import { initialDevelopmentValues } from '../constants';

interface DevelopmentProps {
    values: DevelopmentValues;
    dealUnits: number;
    dealSF: number;
    proFormaModelId: number;
    onUpdate: (data: any) => void;
}

const Development: React.FC<DevelopmentProps> = ({
    values, dealUnits, dealSF, proFormaModelId, onUpdate,
}) => {
    const [formData, setFormData] = useState(() => values || initialDevelopmentValues);

    useEffect(() => {
        if (onUpdate) {
            onUpdate(formData);
        }
    }, [formData, onUpdate]);

    const [touched, setTouched] = useState<Record<string, boolean>>({});
    const [sourceTouched, setSourceTouched] = useState(formData.sources.map(() => ({})));

    const handleInputChange = (key: string, value: number | string) => {
        setFormData((prev: any) => {
            const updated = { ...prev, [key]: value };
            if (key === 'hardCosts') {
                updated.totalHardCosts = Number(value) * dealSF;
            } else if (key === 'totalHardCosts') {
                updated.hardCosts = Number(value) / dealSF;
            } else if (key === 'softCosts') {
                updated.totalSoftCosts = Number(value) * dealSF;
            } else if (key === 'totalSoftCosts') {
                updated.softCosts = Number(value) / dealSF;
            }
            return updated;
        });
        setTouched(prev => ({ ...prev, [key]: true }));
    };

    const handleSourcesChange = (sources: any[]) => {
        setFormData((prev: any) => ({ ...prev, sources }));
        setSourceTouched(sources.map(() => ({})));
    };

    const handleSourcesBlur = (index: number, field: string) => {
        setSourceTouched((prev: any) => {
            const next = [...prev];
            next[index] = { ...next[index], [field]: true };
            return next;
        });
    };

    const totalUses = useMemo(
        () => formData.acquisitionCosts + formData.totalHardCosts + formData.totalSoftCosts
            + formData.interestReserve + formData.developerFeeAmount,
        [formData],
    );

    const totalSources = useMemo(
        () => formData.sources.reduce((acc: number, curr: { amount: any; }) => acc + Number(curr.amount), 0),
        [formData.sources],
    );

    return (
        <div className="Development p-3">
            <Uses
                values={formData}
                onChange={handleInputChange}
                onBlur={() => {}}
                dealSF={dealSF}
                dealUnits={dealUnits}
                proFormaModelId={proFormaModelId}
                totalSources={totalSources}
                errors={{}}
                touched={touched}
            />
            <Sources
                sources={formData.sources}
                onChange={handleSourcesChange}
                onBlur={handleSourcesBlur}
                totalUses={totalUses}
                totalSources={totalSources}
                errors={[]}
                touched={sourceTouched}
            />
        </div>
    );
};

export default Development;
